import React, { useEffect, useRef } from "react";

import { EditableTextarea } from "./AutoResizableTextarea.styles";

type AutoResizableTextareaProps = Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  "value" | "onChange"
> & {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const AutoResizableTextarea: React.FC<AutoResizableTextareaProps> = ({
  value,
  onChange,
  disabled = false,
  ...rest
}) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const resize = () => {
    if (!textareaRef.current) return;
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event);
    resize();
  };

  useEffect(() => {
    resize();
  }, [value]);

  return (
    <EditableTextarea
      {...rest}
      ref={textareaRef}
      value={value}
      onChange={handleChange}
      disabled={disabled}
    />
  );
};

export default AutoResizableTextarea;